import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CartItem, MenuItem } from '../data/mock';
import { HttpClient } from '@angular/common/http';
import { MatrixDto } from '../Model/matrix-dto';
import { ApiFactoryEndPoints } from '../common/api-factory-end-points';
import { Product } from '../Model/product';
import { GoogleCustomer } from '../Model/googlecustomer';
import { LocalStorageService } from './local-storage.service';
import { CartDetails } from '../Model/cart-details';
import { ToastService } from './toast.service';
import { WebOrderMinimumDateTimeSetup } from '../Model/web-order-minimum-date-time-setup';
import { WebOrderMinimumValueSetup } from '../Model/web-order-minimum-value-setup';
import { WebOrderDeliverySetupDto } from '../Model/web-order-delivery-setup-dto';
import { State } from '../Model/state';
import { NameWithIdDto } from '../Model/name-with-id-dto';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  private cartItems: CartItem[] = [];
  private cartSubject = new BehaviorSubject<CartItem[]>([]);
  cart$ = this.cartSubject.asObservable();

  googleCustomer: GoogleCustomer;
  cartDetails: CartDetails = new CartDetails();

  private cartSetUpSubscription: Subscription;

  private readonly STORAGE_KEY = 'selectedDeliveryDetails';


  constructor(
    private http: HttpClient,
    private apiFactory: ApiFactoryEndPoints,
    private localStorage: LocalStorageService,
    private toastrService: ToastService
  ) {
    this.loadCart();
  }

  private loadCart() {
    const savedCart = localStorage.getItem('capitalFoodCart');
    if (savedCart) {
      this.cartItems = JSON.parse(savedCart);
      this.cartSubject.next(this.cartItems);
    }
  }

  private saveCart() {
    localStorage.setItem('capitalFoodCart', JSON.stringify(this.cartItems));
    this.cartSubject.next(this.cartItems);
  }

  getCart(): CartItem[] {
    return this.cartItems;
  }

  getCartCount(): number {
    return this.cartItems.reduce((sum, item) => sum + item.quantity, 0);
  }

  // addToCart(item: MenuItem, restaurantId: number, restaurantName: string) {
  //   const existingItem = this.cartItems.find(c => c.id === item.id);
  //   if (existingItem) {
  //     existingItem.quantity++;
  //   } else {
  //     this.cartItems.push({
  //       ...item,
  //       quantity: 1,
  //       restaurantId,
  //       restaurantName
  //     });
  //   }
  //   this.saveCart();
  // }

  addToCart(item: Product, restaurantId: number, restaurantName: string) {
    const existingItem = this.cartItems.find(c => c.product_Code === item.product_Code);
    if (existingItem) {
      existingItem.quantity++;
    } else {
      this.cartItems.push({
        ...item,
        quantity: 1,
        restaurantId,
        restaurantName
      });
    }
    this.saveCart();
  }

  // updateQuantity(itemId: number, quantity: number) {
  //   this.cartItems = this.cartItems
  //     .map(item =>
  //       item.id === itemId
  //         ? { ...item, quantity }
  //         : item
  //     )
  //     .filter(item => item.quantity > 0);

  //   this.saveCart();
  // }

  updateQuantity(itemId: number, quantity: number) {
    this.cartItems = this.cartItems
      .map(item =>
        item.product_Code === itemId
          ? { ...item, quantity }
          : item
      )
      .filter(item => item.quantity > 0);

    this.saveCart();
  }


  // removeItem(itemId: number) {
  //   this.cartItems = this.cartItems.filter(c => c.id !== itemId);
  //   this.saveCart();
  // }

  removeItem(itemId: number) {
    this.cartItems = this.cartItems.filter(c => c.product_Code !== itemId);
    this.saveCart();
  }

  // getItemQuantity(itemId: number): number {
  //   const item = this.cartItems.find(c => c.id === itemId);
  //   return item ? item.quantity : 0;
  // }

  getItemQuantity(itemId: number): number {
    const item = this.cartItems.find(c => c.product_Code === itemId);
    return item ? item.quantity : 0;
  }

  clearCart() {
    this.cartItems = [];
    this.saveCart();
  }

  getVisitorCount(api: string, type: string) {
    return this.http.get(api + "/" + type, {
      responseType: "json",
    });
  }

  getMatrixList(currentUrl: string) {
    return this.http.get<MatrixDto[]>(this.apiFactory.getMatrixDetails + "/" + currentUrl);
  }

  getOfferDetails(url: string, locId: any, productCode: number[], currentUrl: string) {
    return this.http.get<any>(
      url + "/" + locId + "/" + productCode + "/" + currentUrl
    );
  }

  getOfferAllowFor(url: string, currentUrl: string, type: string) {
    return this.http.get<any>(url + "/" + currentUrl + "/" + type);
  }

  getWebOrderBestProductSetup(url: string, currentUrl: string) {
    return this.http.get<any[]>(url + "/" + currentUrl);
  }



  getProductCart(url: string, email: string, currentUrl: string) {
    return this.http.get<any>(url + "/" + email + "/" + currentUrl, { responseType: "json" });
  }

  getCompanyByLocId(url: string, locId: number) {
    return this.http.get<any>(url + "/" + locId);
  }

  getLocIdByUrl(url: string, currentUrl: string) {
    return this.http.get<any>(url + "/" + currentUrl);
  }

  getWebOrderMinimumDateTimeDetails(currentUrl: string) {
    return this.http.get<WebOrderMinimumDateTimeSetup>(
      this.apiFactory.getWebOrderMinimumDateTimeDetails + "/" + currentUrl
    );
  }

  getTimeSlotList(url: string, currentUrl: string, locId?: number) {
    let finalUrl = locId ? `${url}/${currentUrl}/${locId}` : `${url}/${currentUrl}`;
    return this.http.get<any[]>(finalUrl);
  }

  getMinimumOrderList(currentUrl: string) {
    return this.http.get<WebOrderMinimumValueSetup>(
      this.apiFactory.getMinimumOrderDetails + "/" + currentUrl
    );
  }

  getDeliveryList(currentUrl: string, locId: number, longitude: number, latitude: number) {
    return this.http.get<WebOrderDeliverySetupDto>(
      this.apiFactory.getDeliverySetupDetails + "/" + currentUrl + "/" + locId + "/" + longitude + "/" + latitude
    );
  }

  cashRegProcess(url: string, posData: any) {
    return this.http.post(url, posData);
  }

  checkServiceAllowedOrNot(url: string, posData: any) {
    return this.http.post<any>(url, posData);
  }

  private visitId: string = '';

  logVisit(url: string, user: any) {
    return this.http.post<{ id: string }>(url, user).subscribe(res => {
      this.visitId = res.id;
    });
  }

  logPayClick(url: string) {
    if (this.visitId) {
      this.http.post(url, { id: this.visitId }).subscribe();
    }
  }

  getGatewaySetup(url: string, locId: number, provider: string, currentUrl: string) {
    return this.http.get<any>(url + "/" + locId + "/" + provider + "/" + currentUrl)
  }

  checkPaytmStatus(url: string, transNo: string, currentUrl: string) {
    return this.http.get<any>(url + "/" + transNo + "/" + currentUrl)
  }

  insertWebOrderTemp(url: string, orderId: string, req: any) {
    return this.http.post<any>(url + "/" + orderId, req, {
      responseType: "json",
    });
  }

  getMinimumDateTimeDetails(url: string, currentUrl: string, locId?: number) {
    let finalUrl = locId ? `${url}/${currentUrl}/${locId}` : `${url}/${currentUrl}`;
    return this.http.get<any>(finalUrl);
  }

  getStateList() {
    return this.http.get<State[]>(this.apiFactory.getStateList);
  }
  getDistrictByStateCode(url: string, stateCode: number) {
    return this.http.get<NameWithIdDto[]>(url + "/" + stateCode);
  }

  getDeliveryDetails(): { pincode: number; latitude: number; longitude: number } | null {
    const data = localStorage.getItem(this.STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  }
}